import React, { useState, useEffect } from 'react';
import Drawer from '@material-ui/core/Drawer';
import { toast } from 'react-toastify';
import {
  listarOcorrenciasSolicitaDebMunicipio,
  inserirOcorrenciaSolicitaDebMunicipio,
  excluirOcorrenciaSolicitaDebMunicipio,
  listarTitulosOcorrenciaSolicitaDebMunicipio,
} from '~/Services/Service';
import ModalConfirmacao from '~/Components/ModalConfirmacao';
import OcorrenciaLista from './OcorrenciaLista';
import OcorrenciaForm from './OcorrenciaForm';

// Props-only — zero Redux (Gate 1 §7.1 / feedback_no_redux_store)
const SolicitaDebMunicipioOcorrenciaDrawer = ({
  open,
  onClose,
  codigoSolicitacao,
  codigoUsuario,
}) => {
  const [ocorrencias, setOcorrencias] = useState([]);
  const [titulos, setTitulos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [confirmExcluir, setConfirmExcluir] = useState({ show: false, codigoCalc: null, data: null });

  useEffect(() => {
    if (open && codigoSolicitacao) {
      carregar();
      carregarTitulos();
    }
  }, [open, codigoSolicitacao]); // eslint-disable-line

  const carregar = async () => {
    setLoading(true);
    try {
      const resp = await listarOcorrenciasSolicitaDebMunicipio(codigoSolicitacao);
      setOcorrencias(resp || []);
    } catch (err) {
      toast.error('Falha ao carregar ocorrências.');
    } finally {
      setLoading(false);
    }
  };

  const carregarTitulos = async () => {
    try {
      const resp = await listarTitulosOcorrenciaSolicitaDebMunicipio();
      setTitulos(resp || []);
    } catch (err) {
      // não bloqueia — títulos são opcionais
    }
  };

  const handleInserir = async (values) => {
    try {
      await inserirOcorrenciaSolicitaDebMunicipio(codigoSolicitacao, {
        codigo_titulo_ocorrencia: values.codigo_titulo_ocorrencia,
        texto: values.texto,
      });
      toast.success('Ocorrência adicionada.');
      carregar();
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleExcluir = ({ codigoCalc, data }) => {
    setConfirmExcluir({ show: true, codigoCalc, data });
  };

  const handleConfirmarExcluir = async (confirmado) => {
    const { codigoCalc, data } = confirmExcluir;
    setConfirmExcluir({ show: false, codigoCalc: null, data: null });
    if (!confirmado) return;
    try {
      await excluirOcorrenciaSolicitaDebMunicipio(codigoSolicitacao, codigoCalc, data);
      toast.success('Ocorrência excluída.');
      carregar();
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ style: { width: 500, maxWidth: '90vw' } }}
    >
      <div
        style={{
          backgroundColor: '#0747a6',
          color: '#fff',
          padding: '12px 16px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <strong>Ocorrências — Solicitação #{codigoSolicitacao}</strong>
        <button
          type="button"
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            color: '#fff',
            fontSize: '1.2rem',
            cursor: 'pointer',
            lineHeight: 1,
          }}
          aria-label="Fechar"
        >
          &times;
        </button>
      </div>

      <div style={{ padding: 16, overflowY: 'auto', height: '100%' }}>
        <OcorrenciaForm titulos={titulos} onSubmit={handleInserir} />
        <hr />
        <OcorrenciaLista
          ocorrencias={ocorrencias}
          codigoUsuario={codigoUsuario}
          onExcluir={handleExcluir}
          loading={loading}
        />
      </div>

      <ModalConfirmacao
        show={confirmExcluir.show}
        title="Excluir Ocorrência"
        message="Confirma a exclusão desta ocorrência?"
        onClose={handleConfirmarExcluir}
      />
    </Drawer>
  );
};

export default SolicitaDebMunicipioOcorrenciaDrawer;
